<template>
  <div class="px-2">
    <div v-bind:class="getClass()" data-cy="list-tenants-name">
      <span v-if="!item.name" class="font-italic">
        {{$t('console.tenantNotConnected')}}
      </span>
      <span v-else>
        {{ item.name || item.nodes[0].name }}
      </span>
    </div>
    <div v-bind:class="getClass()" data-cy="list-tenants-users">
      {{ item.totalUsers }}
    </div>
    <div v-bind:class="getClass()" data-cy="list-tenants-folder">
      <v-menu v-if="item.nodes.length > 1">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" elevation="0" variant="text" color="primary">
            {{ item.nodes.length }} folders
            <v-icon color="primary" end>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(node, index) in item.nodes"
            :key="index"
            :title="node.name"
          />
        </v-list>
      </v-menu>
      <template v-else>
        {{ item.nodes[0].name }}
      </template>
    </div>

    <div data-cy="list-tenant-connections-actionsColumn">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TenantListItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      showActionMenu: false,
    };
  },
  methods: {
    getClass: function() {
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
